/* Aftellen naar middernacht in Brazilië (15-09).
   Elk element met data-br-countdown krijgt de resterende tijd als 23:14:07. São Paulo,
   dus elke bezoeker ziet dezelfde stand; Brazilië kent geen zomertijd meer. */
(function () {
  var fmt = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'America/Sao_Paulo', hour12: false,
    hour: '2-digit', minute: '2-digit', second: '2-digit'
  });
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function tick() {
    var el = document.querySelectorAll('[data-br-countdown]');
    if (!el.length) return;
    var p = {};
    fmt.formatToParts(new Date()).forEach(function (x) { p[x.type] = parseInt(x.value, 10); });
    var over = 86400 - ((p.hour % 24) * 3600 + p.minute * 60 + p.second);
    var tekst = pad(Math.floor(over / 3600)) + ':' + pad(Math.floor(over / 60) % 60) + ':' + pad(over % 60);
    Array.prototype.forEach.call(el, function (e) { e.textContent = tekst; });
  }
  tick();
  setInterval(tick, 1000);
  document.addEventListener('shopify:section:load', tick);
})();
